// Utility functions for encoding and decoding shared grocery carts
// Format (versioned): { v:1, f: facilityId, i:[ { b: baseId, q: quantity } ] }
// Encoded as URL-safe Base64 string (no padding, + -> -, / -> _)

export function encodeCart(items, facilityId) {
  const payload = {
    v: 1,
    f: facilityId,
    i: (items || []).filter(it => (it.baseId || it.name) && it.quantity > 0)
      .map(it => ({ b: it.baseId || it.name, q: it.quantity }))
  };
  const json = JSON.stringify(payload);
  const b64 = typeof window === 'undefined'
    ? Buffer.from(json).toString('base64')
    : btoa(unescape(encodeURIComponent(json)));
  return b64.replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
}

export function decodeCart(code) {
  try {
    // If full URL provided, extract list param
    const urlMatch = code.match(/[?&](list|cart)=([A-Za-z0-9_-]+)/);
    if (urlMatch) code = urlMatch[2];
    // Re-pad and restore
    let b64 = code.replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    const json = typeof window === 'undefined'
      ? Buffer.from(b64, 'base64').toString('utf8')
      : decodeURIComponent(escape(atob(b64)));
    const data = JSON.parse(json);
    if (!data || data.v !== 1 || !data.f || !Array.isArray(data.i)) return { error: 'Invalid format' };
    return { data };
  } catch (e) {
    return { error: 'Malformed code' };
  }
}

export function buildShareLink(code) {
  if (typeof window === 'undefined') return code;
  return `${window.location.origin}${window.location.pathname}?list=${code}`;
}
